<template>
  <div
    class="text-[17px] leading-[18px] font-medium text-gray-800 pb-6 border-b border-[#DFDFDF]"
  >
    Account security
  </div>

  <SettingsRow class="h-auto! min-h-[70px] py-[24px]">
    <template #left>
      <div class="flex flex-col w-2/3">
        <div class="mb-1">Password</div>
        <div class="text-[13px] leading-4 text-gray-500">
          Set a unique password to protect your Dacr account.
        </div>
      </div>
    </template>

    <template #right>
      <button
        type="button"
        class="self-start text-link"
        @click="handleChangePasswordClick"
      >
        Change password
      </button>
    </template>
  </SettingsRow>
</template>

<script setup lang="ts">
import SettingsRow from '@/features/settings/components/SettingsRow.vue'
import { useHead } from '@unhead/vue'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'

useHead({ title: 'Security | Dacr' })

const handleChangePasswordClick = () => {
  openDialog(Dialog.ChangePassword)
}
</script>
